import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setupNavigation } from "../../redux/actions/navItemsActions";
import PropTypes from "prop-types";
import GroupSearch from "../groups/GroupSearch";

function GroupsPage(
    {
        setupNavigation,
        user
    }
) {

    const navigationItems =
    {
        sections: [{
            name: 'Routes',
            items: [
                {
                    path: '/user/profile',
                    text: 'Timeline',
                    icon: 'fas fa-clock'
                },
                {
                    path: '/user/routes',
                    text: 'My Routes',
                    icon: 'fas fa-route'
                },
                {
                    path: '/user/bookmarks',
                    text: 'Bookmarked Routes',
                    icon: 'fas fa-star'
                }
            ]
        },
        {
            name: 'Settings',
            items: [
                {
                    path: '/user/settings/general',
                    text: 'Settings',
                    icon: 'fas fa-cog'
                }
            ]
        }]
    };

    useEffect(() => {
        document.title = "Groups | JustGoRide";
        setupNavigation(navigationItems);

    }, []);

    return (
        <div className="mt-2">
            <h3 className="ml-3 mb-3">Groups</h3>
            <GroupSearch />
        </div>
    );
}

GroupsPage.propTypes = {
    setupNavigation: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
    setupNavigation
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupsPage);



// WEBPACK FOOTER //
// ./src/components/groups/GroupsPage.js